<script>
export default {
  methods: {
    getUrlParams (fields, target) {
      fields.forEach(element => {
        let value = this.$route['query'][element]
        if (!value) return

        if (Array.isArray(target[element]) && !Array.isArray(value)) {
          target[element] = [this.parseValue(value)]
        } else {
          target[element] = this.parseValue(value)
        }
      })
    },
    parseValue (value) {
      if (isNaN(parseInt(value)) || value.length !== parseInt(value).toString().length) return value
      return parseInt(value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/mixins/urlParamsMixin.vue